import { ObservableStore } from '@codewithdan/observable-store';
import { filter } from 'rxjs/operators';
import { Store } from '../types';

export class Session extends ObservableStore<any> {
    stateChanged = this.stateChanged.pipe(filter((state) => !!state));

    constructor() {
        super({
            // logStateChanges: true,
            // stateSliceSelector: state => state && state.session,
        });
        // this.setState({ session: {} });
    }

    init(session: Store['session']) {
        this.setState({ session }, 'init_session');
    }

    isSaved() {
        return this.getState().isSaved;
    }

    setPage(page: Store['session']['page']) {
        this.setState(
            ({ session }) => ({
                session: {
                    ...session,
                    page,
                },
            }),
            'change_page'
        );
    }

    get() {
        return this.getState().session;
    }
}

export default new Session();
